import { useTranslation } from 'react-i18next'

import { publicAssetUrl } from '@maxus/website/constants'

type WarnStateProps = {
  tone?: 'empty' | 'permission'
}

const map = {
  empty: {
    title: 'No content available',
    illustration: publicAssetUrl('empty-box.png'),
  },
  permission: {
    title: 'Permission denied',
    illustration: publicAssetUrl('lost-auth.png'),
  },
}

export const WarnState = ({ tone = 'empty' }: WarnStateProps) => {
  const { t } = useTranslation()

  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <img alt={map[tone].title} className="h-[150px] w-[180px] object-contain" src={map[tone].illustration} />
      <div className="mt-7 text-base font-semibold text-text-tertiary">{t(map[tone].title)}</div>
    </div>
  )
}
